module.exports = __webpack_public_path__ + "static/media/logo.44b95054.svg";